"use strict";
var $ = require("../internals/export");
var functionApply = require("../internals/function-apply");
var aCallable = require("../internals/a-callable");
var anObject = require("../internals/an-object");
var fails = require("../internals/fails");
var OPTIONAL_ARGUMENTS_LIST = !fails(function() {
  Reflect.apply(function() {
  });
});
$({ target: "Reflect", stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
  }
});
